import { uuid2 as uuid } from '@/utils';

class Point {
  constructor(id, x, y) {
    this.uuid = id || uuid();
    this.id = this.uuid;
    this.x = +x;
    this.y = +y;
  }
}

export default Point;
